import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { SelectItem, TreeNode } from 'primeng/api';
import { ImageUploadQuestion } from 'src/app/misc/component/dynamic-form/question-imageupload';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import icons from '../../../../misc/data/icons.json';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
} from 'primeng/api';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { ActivatedRoute } from '@angular/router';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-add-unit',
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class AddUnitComponent {
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  header = 'وحدة تنظيمية جديدة';
  @Input() currentParent: any = null;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();


  translator: TranslatorPipe = new TranslatorPipe()

  exit(value: any) {
    this.closeModal.emit(value);
  }

  skelition: boolean = true;
  loader : boolean = false

  @Input() updateData: any;


  messages: Message[] = [];
  isIcon: boolean = false;

  city: Array<Location | any> = [];

  questions: QuestionBase<string>[] = [];
  treedata: TreeNode[] = [];
  iconOptions: SelectItem[] = [];
  constructor(
    private dataService: DataService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
    private activeRoute: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.getData();
  }

  async getData() {
    this.getIcons();
    await Promise.all([
      this.getTreeData(),
      this.getCity(),
      this.getTypes(),
      this.getCategory(),
    ]).then((e) => {
      this.skelition = false;
    });
    this.makequestion();
  }
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['currentParent']) {
      this.currentParent = simpleChange['currentParent'].currentValue;
      this.makequestion();
    }
  }

  makequestion() {
    console.log('UPDATE DATA', this.updateData);
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم الوحدة التنظيمية',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        value: this.updateData?.name
      }),

      new DropdownQuestion({
        key: 'location',
        label: 'المدينة',
        options: this.city.map((item) => {
          return {
            label: item.name,
            value: item._id,
            icon: item.icon,
          };
        }),
        order: 2,
        filter: true,
        value: this.updateData?.location?._id
      }),

      new DropdownQuestion({
        key: 'category',
        label: 'التصنيف',
        options: this.categories.map((item) => {
          return {
            label: item.name,
            value: item._id,
            icon: `pi pi-${item.icon}`,
          };
        }),
        order: 3,
        value: this.updateData?.category?._id
      }),

      new DropdownQuestion({
        key: 'type',
        label: 'النوع',
        options: this.types.map((item) => {
          return {
            label: item.name,
            value: item._id,
            icon: `pi pi-${item.icon}`,
          };
        }),
        order: 5,
        value: this.updateData?.type?._id
      }),

      new TreeSelectQuestion({
        key: 'parent',
        label: 'الصنف الأب',
        treeOptions: this.treedata,
        order: 6,
        icon: 'pi pi-file',
        filter: true,
        value: this.currentParent ?? this.updateData?.parent
      }),

      new DropdownQuestion({
        key: 'isManager',
        label: 'مدير',
        required: true,
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 7,
        value: this.updateData?.isManager
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 8,
        value: true,
        visibility: this.updateData != undefined ? 'true' : "false"
      }),


      new RadioButtonQuestion({
        key: 'icontype',
        label: 'نوع الشعار',
        options: [
          { label: 'صورة', icon: 'pi pi-image', value: false },
          { label: 'ايقونة', icon: 'pi pi-flag', value: true },
        ],
        order: 6,
        value: this.updateData ? this.updateData.image.includes('pi-') : false
      }),

      new ImageUploadQuestion({
        key: 'image',
        label: 'الصورة',
        order: 9,
        isImage: true,
        required: false,
        className: 'col-md-6 col-sm-12 col-12',
        visibility: (!this.updateData?.image.includes('pi-')).toString(),
        value: this.updateData?.image
      }),

      new ImageUploadQuestion({
        key: 'image_sq',
        label: 'الشعار',
        order: 10,
        isImage: true,
        required: false,
        className: 'col-md-6 col-sm-12 col-12',
        visibility: (!this.updateData?.image.includes('pi-')).toString(),
        value: this.updateData?.image_sq
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'الايقونات',
        required: false,
        
        order: 15,
        className: 'col-md-6 col-sm-12 col-12',
        visibility: this.updateData != undefined ? this.updateData?.image.includes('pi-').toString() : "false",
        value: this.updateData?.image
      }),

      new CheckBoxQuestion({
        key: 'allowSingleUser',
        label: this.translate('Single User Only'),
        required: true,
        order: 15,
        className: 'col-md-6 col-sm-12 col-12',
        value: this.updateData?.allowSingleUser
      })
    ];
  }

  addOU = async ($event: any) => {
    
console.log('EVENT THIS',$event)
    try {
    this.loader = true
      if (typeof $event === 'string') {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: $event },
        ];
        this.loader = false
        return;
      }
   

      let data = $event;
      if (data.parent) {
        if (data.parent.label == 'الجهات المشاركة') {
          data.parent = null;
        } else {
          data.parent = data.parent._id;
        }
      } else delete data.parent;

      if (this.isIcon || data.icontype) {
        data.image = data.icon;
        data.image_sq = data.icon;
      }
      delete data.icontype;
      delete data.icon;
      console.log(data);
      console.log(' Data Recieved ====> 2', data);
      if (this.updateData != undefined && this.updateData != null) {
        data._id = this.updateData._id;
      }
      if(this.updateData) {
        //let cleanres = await this.dataService.getData('ou/clean');
      }
      let res = await this.dataService.postData('ou', data, this.updateData ? 'PUT' : 'POST');
      if (res.error) {
        this.loader = false
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.loader = false
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      this.DynamicFormComponent.resetForm();
      this.exit(res.data);
      this.makequestion();
    } catch (error) {
      console.log(error);
    }
  };

  async getTreeData() {
    this.treedata = await this.permissionService.extractOUChildren('OU', 'c');
    console.log('TREE DATAA',this.treedata)
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            _id: location._id,
            name: location.name,
            icon: 'pi pi-map-marker',
          };
        });
        console.log('this.city =>', this.city);
      }
    } catch (error) {
      console.log(error);
    }
  }

  categories: any[] = [];
  types: any[] = [];

  async getCategory() {
    try {
      let res = await this.dataService.getData('ou-category');
      if (!res.error) {
        this.categories = res.data;
        console.log('getCategory =>', this.categories);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getTypes() {
    try {
      let res = await this.dataService.getData('ou-type');
      if (!res.error) {
        let allowedTags = this.permissionService.extractTags('OU_TYPE', 'r');
        this.types = res.data.filter((type: any) => allowedTags.includes(type.tag));

        console.log('types =>', this.types);
      }
    } catch (error) {
      console.log(error);
    }
  }

  getIcons() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
  }

  handleImgTypeChange(val: boolean) {
    this.isIcon = val;

    let iconQuestion = this.questions.find((e) => e.key == 'icon');
    let imgQuestion = this.questions.find((e) => e.key == 'image');
    let imgSqQuestion = this.questions.find((e) => e.key == 'image_sq');

    if (iconQuestion) {
      iconQuestion.visibility = this.isIcon.toString();
    }
    if (imgQuestion) {
      imgQuestion.required = false;
      imgQuestion.visibility = (!this.isIcon).toString();
    }
    if (imgSqQuestion) {
      imgSqQuestion.required = false;
      imgSqQuestion.visibility = (!this.isIcon).toString();
    }
  }
}
